import React from "react";
import { Box, Button, Paper } from "@mui/material";
import { Table, TableBody, TableCell } from "@mui/material";
import { TableContainer, TableHead, TableRow } from "@mui/material";
import moment from "moment";
import Loader from "../../components/Loader";

function Sales({ items, mode, onChange, loadMore, loading, }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>Selected</TableCell>
            {mode == "sales" ? (
              <TableCell>Bill Number</TableCell>
            ) : (
              <TableCell>Description</TableCell>
            )}
            <TableCell>Customer</TableCell>
            <TableCell>Credit</TableCell>
            <TableCell>Profit</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Created</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, i) => {
            let credit = item.credit ? item.credit : item?.paid;
            return (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  <input
                    type="checkbox"
                    defaultChecked=""
                    onChange={() => onChange(item)}
                  />
                </TableCell>
            
                {mode == "sales" ? (
                  <TableCell component="th" scope="row" className="fs-8">
                    {item.billNumber}
                  </TableCell>
                ) : (
                  <TableCell component="th" scope="row" className="fs-8">
                    {item.billNumber}
                  </TableCell>
                )}
                    <TableCell component="th" scope="row" className="fs-8">
                    {item.customer}
                  </TableCell>
                <TableCell component="th" scope="row" className="fs-8">
                  {item?.total ?? 0}
                </TableCell>
                <TableCell component="th" scope="row" className="fs-8">
                  {item?.profit}
                </TableCell>
                <TableCell component="th" scope="row" className="fs-8">
                  Bill
                </TableCell>
                <TableCell component="th" scope="row" className="fs-8">
                  {moment.unix(item?.created_at).format("DD-MM-YYYY")}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {/* <Box sx={{ display: "flex", justifyContent: "center" }}>
        {loading && <Loader loading={loading} />}
        {!loading && items && items.length > 19 && (
          <Button sx={{ mt: 1, mb: 1 }} variant="outlined" onClick={loadMore}>
            Load More
          </Button>
        )}
      </Box> */}
    </TableContainer>
  );
}

export default Sales;
